<template>
  <div style="z-index: 3; transform: translateZ(0)">
    <div class="bottom-wrapper">
      <ProductsSliderSimilar
        v-if="productData?.id"
        :products-ids="[productData.id.toString()]"
        :add-to-cart-fn="addToCartFn"
        :visible-overflow="isMobileOrTablet"
      />

      <ProductsSliderLastSeen
        :add-to-cart-fn="addToCartFn"
        :hided-ids="hidedIds"
        :visible-overflow="isMobileOrTablet"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { TProductCardAddToCartFn } from '@/features/product-card';
import { useProductPage } from '../../business/use-product-page';
import { useCart } from '@/features/store/cart';

import ProductsSliderSimilar from '@/features/products-sliders/ui/ProductsSliderSimilar.vue';
import ProductsSliderLastSeen from '@/features/products-sliders/ui/ProductsSliderLastSeen.vue';
import { useMedia } from '@mm-frontend/mm-web-ui-kit';

// Use the correct composable that other components use
const { state } = useProductPage();
const { isMobileOrTablet } = useMedia();

// Get cart function for adding products to cart
const { addProductToCartLite } = useCart();

const productData = computed(() => {
  return state.product;
});

const hidedIds = computed(() => (productData.value?.id ? [productData.value?.id.toString()] : []));

// Use default cart function - it will be passed to sliders
const addToCartFn: TProductCardAddToCartFn = addProductToCartLite;
</script>

<style scoped lang="stylus">
.bottom-wrapper
  position relative
  background-color white
  padding-top 16px
</style>
